// src/components/ValueProps.js
import React from 'react';
import { IoTimerOutline, IoRocketOutline, IoBarChartOutline } from 'react-icons/io5';

const benefits = [
  {
    icon: IoTimerOutline,
    title: "Save 10+ Hours a Week",
    description: "Automate content creation, scheduling, and reporting to reclaim your time and focus on strategy, not busywork."
  },
  {
    icon: IoRocketOutline,
    title: "Triple Your Engagement",
    description: "Our AI analyzes your audience and suggests content that resonates, leading to more likes, comments, and shares."
  },
  {
    icon: IoBarChartOutline,
    title: "Drive Measurable Growth",
    description: "Connect social performance directly to business goals with clear, actionable analytics that prove your ROI."
  }
];

const ValueProps = () => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            The Outcomes Your Business Needs
          </h2>
          <p className="mt-4 text-lg text-dark-text-secondary">
            Oolook isn't just another tool. It's a growth engine designed for tangible results.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 gap-12 sm:mt-20 lg:max-w-none lg:grid-cols-3">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="flex flex-col items-center text-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end">
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="mt-5 text-xl font-semibold text-dark-text-primary">{benefit.title}</h3>
              <p className="mt-2 text-base text-dark-text-secondary">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;